// Simplified structure v2.0 - Model + Size only (Years/Processor/Sub-processor removed)
// Legacy full structure preserved in: product_data_LEGACY_full_structure.js
// 
// SIMPLIFICATION RATIONALE:
// - Discontinued bundles (only "Single Dock" now supported)
// - All MacBook models (2016-2025, M1/M2/M3/M4/M5/Intel) use the same dock based on size
// - Removed complex processor/year selection to streamline user experience
//
// Selection flow: Model (Pro/Air) → Size (13"/14"/15"/16") → Auto-select "Single Dock"

var product_data = [
  // ═══════════════════════════════════════════════════════════════
  // MACBOOK PRO - All generations consolidated by size
  // ═══════════════════════════════════════════════════════════════
  
  // MacBook Pro 14" - Covers M1/M2/M3/M4/M5 Pro models (2021-2025)
  {
    "id": 44613585797284,
    "dockType": "Single Dock",
    "model": "Pro",
    "sizes": "14",
    "pre_order": false,
    "warningText": false
  },
  
  // MacBook Pro 16" - Covers M1/M2/M3/M4 Pro/Max models (2021-2025)
  {
    "id": 44613585830052,
    "dockType": "Single Dock",
    "model": "Pro",
    "sizes": "16",
    "pre_order": false,
    "warningText": false
  },
  
  // ═══════════════════════════════════════════════════════════════
  // MACBOOK AIR - All generations consolidated by size
  // ═══════════════════════════════════════════════════════════════
  
  // MacBook Air 13" - Covers M1/M2/M3/M4 models (2020-2025) + Intel (2018-2020)
  {
    "id": 44613585862820,
    "dockType": "Single Dock",
    "model": "Air",
    "sizes": "13",
    "pre_order": false,
    "warningText": false
  },
  
  // MacBook Air 15" - Covers M2/M3/M4 models (2023-2025)
  {
    "id": 44613585895588,
    "dockType": "Single Dock",
    "model": "Air",
    "sizes": "15",
    "pre_order": false,
    "warningText": false
  }
]

// ═══════════════════════════════════════════════════════════════
// BUNDLE ADAPTER CONFIGURATIONS (LEGACY - Bundles discontinued)
// ═══════════════════════════════════════════════════════════════
// NOTE: Bundles were discontinued in January 2026. Only "Single Dock" 
// is now available. This configuration is preserved for reference only.

var bundle_adapter_configurations = {
  "Single Dock": {
    adapters: []  // No additional items
  }
};

// ═══════════════════════════════════════════════════════════════
// DOCKING STATION OVERVIEW SPECS
// ═══════════════════════════════════════════════════════════════

var docking_station_overview = {
  "Type C": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "Up to 140W charging via MagSafe",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  },
  "Type D": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "Up to 140W charging via MagSafe",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  },
  "Type E": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "Up to 140W charging via MagSafe",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  },
  "Type F": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "Up to 140W charging via MagSafe",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  }
};
